import { render, staticRenderFns } from "./IntroducingUser.vue?vue&type=template&id=9d8bdfe4&scoped=true&"
import script from "./IntroducingUser.vue?vue&type=script&lang=js&"
export * from "./IntroducingUser.vue?vue&type=script&lang=js&"
import style0 from "./IntroducingUser.vue?vue&type=style&index=0&id=9d8bdfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8bdfe4",
  null
  
)

export default component.exports